

















export default {
  name: "SectionContainer",
  props: {
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    centered: {
      type: Boolean,
      default: false
    }
  }
};
